import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-82b56d70"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "relative z-[60]"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-1/6 h-1 bg-gray-400 rounded-2xl mt-4 mx-auto" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "p-4 h-full w-full overflow-y-auto" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-1/6 h-1 bg-gray-400 rounded-2xl mt-4 mb-4" }, null, -1))
const _hoisted_6 = { class: "p-4 h-full w-full overflow-y-auto" }

import { useDialogsStore } from "@/store/useDialogsStore";
import { computed, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'BottomSheet',
  props: {
    dialogId: {},
    outSideClosable: { type: Boolean },
    allDraggable: { type: Boolean }
  },
  setup(__props: any) {

const dialogsStore = useDialogsStore();

const props = __props;

const isOpen = computed<boolean>(() => {
  return dialogsStore.dialogs[props.dialogId];
});

const isDragging = ref(false);
const initialMouseY = ref(0);
const offsetY = ref(0);
const modalRef = ref<HTMLElement | null>(null);

const startDrag = (e: MouseEvent | TouchEvent) => {
  const clientY =
    "touches" in e ? e.touches[0].clientY : (e as MouseEvent).clientY;
  if (isInDraggableArea(e.target)) {
    e.preventDefault();
    isDragging.value = true;
    initialMouseY.value = clientY;
  }
};

const onDrag = (e: MouseEvent | TouchEvent) => {
  if (isDragging.value) {
    const clientY =
      "touches" in e ? e.touches[0].clientY : (e as MouseEvent).clientY;
    e.preventDefault();
    const delta = clientY - initialMouseY.value;

    if (delta > 0) {
      offsetY.value = delta;
    }
  }
};

const stopDrag = () => {
  if (isDragging.value) {
    isDragging.value = false;
    if (offsetY.value > 200) {
      dialogsStore.closeAllModals();
      offsetY.value = 0;
    } else {
      offsetY.value = 0;
    }
  }
};

const isInDraggableArea = (target: EventTarget | null): boolean | null => {
  return modalRef.value && modalRef.value.contains(target as Node);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, null, {
    default: _withCtx(() => [
      (isOpen.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", {
              class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity bottom-0",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(dialogsStore).closeAllModals()))
            }),
            (!props.allDraggable)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  style: _normalizeStyle({ transform: `translateY(${offsetY.value}px)` }),
                  ref_key: "modalRef",
                  ref: modalRef,
                  class: "bg-custom-primaryBlack transition-opacity fixed inset-x-0 bottom-0 w-full h-4/5 md:w-2/5 m-auto rounded-t-2xl flex flex-col items-center"
                }, [
                  _createElementVNode("div", {
                    id: "modal",
                    class: _normalizeClass(["w-full", { draggable: !isDragging.value, dragging: isDragging.value }]),
                    onMousedown: startDrag,
                    onMousemove: onDrag,
                    onMouseup: stopDrag,
                    onTouchstart: startDrag,
                    onTouchmove: onDrag,
                    onTouchend: stopDrag
                  }, _hoisted_3, 34),
                  _createElementVNode("div", _hoisted_4, [
                    _renderSlot(_ctx.$slots, "default")
                  ])
                ], 4))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  id: "modal",
                  ref_key: "modalRef",
                  ref: modalRef,
                  style: _normalizeStyle({ transform: `translateY(${offsetY.value}px)` }),
                  class: _normalizeClass(["bg-custom-primaryBlack transition-opacity fixed inset-x-0 bottom-0 w-full h-4/5 md:w-2/5 m-auto rounded-t-2xl flex flex-col items-center", { draggable: !isDragging.value, dragging: isDragging.value }]),
                  onMousedown: startDrag,
                  onMousemove: onDrag,
                  onMouseup: stopDrag,
                  onTouchstart: startDrag,
                  onTouchmove: onDrag,
                  onTouchend: stopDrag
                }, [
                  _hoisted_5,
                  _createElementVNode("div", _hoisted_6, [
                    _renderSlot(_ctx.$slots, "default")
                  ])
                ], 38))
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }))
}
}

})